export const VIRTUAL_KEYBOARD_LAYOUT = [
    // 1
    // tslint:disable-next-line:max-line-length
    '\u0d05', '\u0d06', '\u0d07', '\u0d08', '\u0d09', '\u0d0a', '\u0d0b', '\u0d0e', 
    '\u0d0f', '\u0d10', '\u0d12', '\u0d13', '\u0d14', '\u0d57', '\u0d46', '\u0d02',  
    // 2
    // tslint:disable-next-line:max-line-length
    '\u0d15', '\u0d16', '\u0d17', '\u0d18', '\u0d19', '\u0d3f', '\u0d40', '\u0d41', '\u0d42', '\u0d43',
    '\u0d4d\u0d2f', '\u0d47',  '\u0d3e', '\u0d4d', '\u0d4d\u0d30', '\u0d4d\u0d35',
    // 3
    // tslint:disable-next-line:max-line-length
    '\u0d1a', '\u0d1b', '\u0d1c', '\u0d1d', '\u0d1e', '\u0d26\u0d4d\u0d27', '\u0D7B\u0d4d\u0d31',
    '\u0d2e\u0d4d\u0d2a', '\u0d28\u0d4d\u0d24', '\u0d24\u0d4d\u0d25', '\u0d19\u0d4d\u0d15', '\u0d28\u0d4d\u0d28',
     '\u0d28\u0d4d\u0d2e', '\u0d2a\u0d4d\u0d2a', '\u0d15\u0d4d\u0d15', '\u0d19\u0d4d\u0d19',
    // 4
    // tslint:disable-next-line:max-line-length
    '\u0d1f', '\u0d20', '\u0d21', '\u0d22', '\u0d23', '\u0d23\u0d4d\u0d1f', '\u0D7A', '\u0D7C', '\u0D7B', '\u0D7D',
    '\u0D7E', '\u0d1c\u0d4d\u0d1e', '\u0d28\u0d4d\u0d26', '\u0d1c\u0d4d\u0d1c', '\u0d2c\u0d4d\u0d2c', '\u0d26\u0d4d\u0d26',
    // 5
    // tslint:disable-next-line:max-line-length
    '\u0d24', '\u0d25', '\u0d26', '\u0d27', '\u0d28', '\u0d36\u0d4d\u0d1a', '\u0d24\u0d4d\u0d38', '\u0d24\u0d4d\u0d2d', 
    '\u0d15\u0d4d\u0d24', '\u0d37\u0d4d\u0d1f', '\u0d38\u0d4d\u0d25', '\u0d38\u0d4d\u0d31\u0d4d\u0d31', 
    '\u0d28\u0d4d\u0d27', '\u0d32\u0d4d\u0d32', '\u0d17\u0d4d\u0d17', '\u0d23\u0d4d\u0d23',
    // 6
    // tslint:disable-next-line:max-line-length
    '\u0d2a', '\u0d2b', '\u0d2c', '\u0d2d', '\u0d2e', '\u0d32\u0d4d\u0d2a', '\u0d24\u0d4d\u0d2e', '\u0d1e\u0d4d\u0d1e',
    '\u0d1e\u0d4d\u0d1a', '\u0d28\u0d4d\u0d25', '\u0d23\u0d4d\u0d2e', '\u0d24\u0d4d\u0d24', '\u0d1a\u0d4d\u0d1a',
    '\u0d33\u0d4d\u0d33', '\u0d38\u0d4d\u0d38', '\u0d36\u0d4d\u0d36',
    // 7
    // tslint:disable-next-line:max-line-length
    '\u0d2f', '\u0d30', '\u0d32', '\u0d35', '\u0d36', '\u0d37', '\u0d38', '\u0d39', '\u0d33', '\u0d34',
    '\u0d31', '\u0d15\u0d4d\u0d37', '\u0d31\u0d4d\u0d31', '\u0d1f\u0d4d\u0d1f', '\u0d2e\u0d4d\u0d2e','\u0d03',
];
